import { useEffect, useRef, useState } from 'react';

import { getQuickQuote } from '@/apiCalls/matchingEngine';
import { DisplayComponent } from '@/components/DisplayComponent';
import { Header } from '@/components/Header';
import { selectPartner, selectTestDriveAgreement } from '@/context/display';
import { useAppSelector } from '@/context/storeHooks';

import { TestDriveAgreementButton } from './TestDriveAgreementButton';

export const testId = 'TestDriveAgreement';

export function TestDriveAgreement(): JSX.Element {
    // ***** Redux *****
    const partner = useAppSelector(selectPartner);
    const { locationName } = partner;

    // ***** Local State *****
    const [atBottom, setAtBottom] = useState(false);

    // ***** CONSTANTS *****
    const baseId = 'screen-TestDriveAgreement';

    // ***** Scroll Logic *****
    // Ref for the scrollable container
    const scrollContainerRef = useRef<HTMLDivElement | null>(null);

    // Function to check if the user is at the bottom
    const checkScrollPosition = (): void => {
        if (scrollContainerRef.current) {
            const container = scrollContainerRef.current;
            const isAtBottom =
                Math.abs(
                    container.scrollHeight -
                        container.scrollTop -
                        container.clientHeight
                ) < 10;
            setAtBottom(isAtBottom);
        }
    };

    // const testDriveAgreementText =
    //     useAppSelector(selectTestDriveAgreement)?.repeat(500) || ''; // CHANGE THIS TO THE ACTUAL AGREEMENT TEXT
    const testDriveAgreementText =
        useAppSelector(selectTestDriveAgreement) || '';

    // On this screen, after the applicant has filled in their details from OCR, we want to re run quick quote because on the next screen after this, we show the lowest repayment price.
    useEffect(() => {
        getQuickQuote();
    }, []);

    // Add initial check when component mounts
    useEffect(() => {
        checkScrollPosition();
    }, []);

    // Attach scroll event listener when the component mounts
    useEffect(() => {
        if (scrollContainerRef.current) {
            const container = scrollContainerRef.current;
            container.addEventListener('scroll', checkScrollPosition);

            // Remove the event listener when the component unmounts
            return () => {
                container.removeEventListener('scroll', checkScrollPosition);
            };
        }
    }, []);

    // ***** Render *****
    return (
        <div data-testid={testId}>
            <DisplayComponent baseId={baseId}>
                <Header />
                <div className='relative w-full min-h-screen flex flex-col items-center justify-start'>
                    <div className='w-full max-w-3xl mt-8'>
                        <h3 className='text-center text-3xl py-3'>Agreement</h3>
                        <h2 className='text-center px-6 pb-4'>
                            Please read and agree to {locationName}&apos;s test
                            drive agreement.
                        </h2>

                        <div
                            ref={scrollContainerRef}
                            className='w-full bg-gray-100 rounded-lg p-2 h-[400px] overflow-y-scroll pb-4 mb-4'
                        >
                            {testDriveAgreementText
                                .split('\n\n')
                                .map((paragraph, index) => (
                                    <p key={index} className='text-base'>
                                        {paragraph}
                                        <br />
                                    </p>
                                ))}
                        </div>
                        <TestDriveAgreementButton
                            baseId={baseId}
                            disabled={!atBottom}
                        />
                    </div>
                </div>
            </DisplayComponent>
        </div>
    );
}
